export const loginKeys = {
  LOG_IN_ALL: () => ['login'],
  POST_LOG_IN: () => ['login', 'postLogin'],
  CHANGE_PASSWORD: () => ['login', 'changePassword'],
  FORGOT_PASSWORD: () => ['login', 'forgotPassword'],
  CHANGE_PASSWORD_FORCE: () => ['login', 'changePassword', 'force']
};
